// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Make Swal2 popups smaller globally */
.swal2-popup {
  font-size: 0.8rem !important;   /* Reduce text size */
  width: 250px !important;        /* Reduce popup width */
  padding: 1em !important;        /* Less padding */
}

.swal2-title {
  color: #020202;
  font-size: 1rem !important;     /* Smaller title */
}

.swal2-html-container {
  font-size: 0.85rem !important;  /* Smaller body text */
}

.swal2-confirm, .swal2-cancel {
  font-size: 0.8rem !important;   /* Smaller buttons */
  padding: 0.4em 1em !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AACA,uCAAuC;AACvC;EACE,4BAA4B,IAAI,qBAAqB;EACrD,uBAAuB,SAAS,uBAAuB;EACvD,uBAAuB,SAAS,iBAAiB;AACnD;;AAEA;EACE,cAAc;EACd,0BAA0B,MAAM,kBAAkB;AACpD;;AAEA;EACE,6BAA6B,GAAG,sBAAsB;AACxD;;AAEA;EACE,4BAA4B,IAAI,oBAAoB;EACpD,6BAA6B;AAC/B","sourcesContent":["\n/* Make Swal2 popups smaller globally */\n.swal2-popup {\n  font-size: 0.8rem !important;   /* Reduce text size */\n  width: 250px !important;        /* Reduce popup width */\n  padding: 1em !important;        /* Less padding */\n}\n\n.swal2-title {\n  color: #020202;\n  font-size: 1rem !important;     /* Smaller title */\n}\n\n.swal2-html-container {\n  font-size: 0.85rem !important;  /* Smaller body text */\n}\n\n.swal2-confirm, .swal2-cancel {\n  font-size: 0.8rem !important;   /* Smaller buttons */\n  padding: 0.4em 1em !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
